import React, { Component } from "react";
import LeftPicture from '../Section/LeftPicture';
import User from "../Section/User";
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picture from "./img/innovation-web.png";
import julien from "./img/julien.png";
import richard from "./img/richard.png";
import edlef from "./img/edlef.png";
import vincent from "./img/vincent.png";
import guy from "./img/guy.png";
import challenge from "./img/challenge.png";
import MainPicture from "../Section/MainPicture";
import integral from "./img/logo-integral-system.png";
import pixel from "./img/pole-pixel-villeurbanne-integral-service.jpg";
import styles from "./About.module.scss";


class About extends Component {
  render() {
    let smalltitle = "Qui somme nous ?";
    let title = "Un Studio Web innovant"
    let description = ["Integral Service est une agence Lyonnaise spécialisée dans les ", <strong>technologies de l'internet</strong>, ". Notre coeur de métier est de réaliser des ", <strong>applications Web innovantes</strong>, " pour répondre aux besoins métiers de nos clients.",
                      <br />, <br />,"L'innovation est au coeur de notre savoir-faire. "];
    let alt = "Integral Service et innovation";

    let smalltitleAbout = "Ce qu'on adore ?";
    let titleAbout = "Relever les défis"
    let descriptionAbout = ["Depuis nos débuts, nous accompagnons nos clients qui nous proposent des ", <strong>défis toujours plus grands à relever!</strong>,<br />, <br />," Nous avons pu travailler sur des complexités fonctionnelles importantes, des volumes de données démentiels, des quantités de visiteurs incroyables, des problématiques techniques complexes, des systèmes d'informations gigantesques... et on adore!"];
    let altAbout = "Challenge Integral Service";


    let industrie4 = [
      "Integral Service fait partie de la société ", <a href="https://www.integral-system.fr" title="Société Integral System">Integral System</a>," créée en 2003, ", <strong>spécialiste de l'informatique industrielle et l'automation</strong>, ".", 
      <br />, <br />, 
      
      "Notre expertise de l'environnement industriel couplé à notre savoir-faire dans le milieu du Web est une combinaison gagnante dans le cadre de la mise en place d'environnements Web au sein des industries ainsi que dans le monde de l'IoT (Internet des Objets). ", <br />, <br />,"Nous vous accompnons dans ",<strong>l'entrée vers l'industrie 4.0.</strong>
    ];
    return (
      <div className={`${styles.aboutcontainer} `}>
            <LeftPicture 
              smalltitle={smalltitle}
              title={title}
              description={description}
              picture={picture}
              alt={alt}
            />

            <div className="team row-bottom-padded-lg row-top-padded-lg">
            <div className="container">

            <h2 className={`text-center ${styles.teamtitle} `}>Une équipe de passionnés</h2>
            <p className={` ${styles.teamparagraph} `}>Notre expérience cumulé dans le Web et le système d'information, nous permet d'appréhender les problématiques métiers de manière efficace et novatrice. </p>
            <div className={`row ${styles.teamcontainer} `}>
              <div className="col-md-4 col-sm-6 col-xs-12">
                <User name="Edlef"
                position="Ninja du Web"
                description="Le processus de conception est bizarre et compliqué, car il implique des personnes, qui sont bizarres et compliquées - Brad Frost"
                picture={edlef}
                alt="Edlef - Développeur Web"
                twitter="https://twitter.com/edlef2" />
              </div>
              <div className="col-md-4 col-sm-6 col-xs-12">
                <User name="Julien"
                position="Web Yoda"
                description="Il semble que la perfection soit atteinte non quand il n'y a plus rien à ajouter, mais quand il n'y a plus rien à retrancher - Antoine de Saint-Exupéry"
                picture={julien}
                alt="Julien Responsable technique Integral Service"
                twitter="https://twitter.com/jurv_dev" />
              </div>
              <div className="col-md-4 col-sm-6 col-xs-12">
                <User name="Richard"
                position="Développeur Full Stack"
                description=" On dit qu’on apprend avec ses erreurs, mais à mon avis c’est une erreur… et si je me trompe au moins j’aurais appris quelque chose ! "
                picture={richard}
                alt="Richard Développeur full stack"
                twitter="https://twitter.com/richard0r" />
              </div>
            </div>
            <div className={`row ${styles.devline2}`}>
              <div className="col-md-4 col-sm-6 col-xs-12">
                <User name="Guy"
                position="Développeur Web"
                description="Il est beaucoup plus intéressant de discuter de la façon de résoudre les problèmes plutôt que de les signaler - Gibson"
                picture={guy}
                alt="Guy Développeur Web"
                twitter="" />
              </div>
              <div className="col-md-4 col-sm-6 col-xs-12">
                <User name="Vincent"
                position="Chef de projet"
                description="La perception d’un problème peut changer à chaque fois que nous le regardons - Antichamber.com"
                picture={vincent}
                alt="Vincent"
                twitter="https://twitter.com/smashou" />
              </div>
            </div>
            </div>
        </div>
        <LeftPictureBackground 
            smalltitle={smalltitleAbout}
            title={titleAbout}
            description={descriptionAbout}
            picture={challenge}
            alt={altAbout}
        />
        <MainPicture title="Industrie et IoT"
                     description ={industrie4}
                     picture={integral}
                     alt="Logo Integral System"
        />
        <div className="container row-bottom-padded-lg row-top-padded-lg">
          <h2 className="text-center">Nous trouver</h2>
          <div className={`row ${styles.findus} row`}>
            <div className="col-md-6">
            <img src={pixel} alt="Photo du pôle Pixel" className="img-fluid" />
            </div>
            <div className="col-md-6">
              <p>Nous sommes installés au sein du <a href="http://www.polepixel.fr/" title="Site officiel du Pôle pixel" target="_blank" rel="nofollow">Pôle Pixel</a> à Villeurbanne qui, en plus de regrouper les studios de Cinéma Rhône-Alpes, intègre des dizaines de sociétés spécialisées dans le numérique !</p>
              <div className={styles.adressabout} itemscope="" itemtype="http://schema.org/Person">
                  <ul>
                      <li><i className="icon-phone"></i>&nbsp;<a href="tel:+33437697209" title="Appeler Integral Service"><span itemprop="telephone">33 (0)4 37 69 72 09</span></a></li>
                      <li><i className="icon-fax"></i>&nbsp;<span itemprop="faxNumber">33 (0)4 72 33 88 45</span></li>
                      <li><i className="icon-envelope"></i>&nbsp;<span itemprop="email">info(at)integral-service.fr</span></li>
                      <li className={styles.details}><i className="icon-location2"></i>&nbsp;<span itemprop="name">INTEGRAL SERVICE</span><br /><div><span itemprop="streetAddress">36 rue Emile Decorps<br /> Batiment 23<br /></span>  <span itemprop="postalCode">69100</span> <span itemprop="addressLocality">VILLEURBANNE, France</span></div></li>
                  </ul>
              </div>
            </div>
          </div>   
          <div className="row find-us-map"> 
              <div className="col-md-12">
                <div className="embed-responsive">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2783.696704183106!2d4.896692015780843!3d45.75722602186329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47f4c1b3c098cb3d%3A0xd9e88d1ca910efc4!2sIntegral+Service!5e0!3m2!1sen!2sfr!4v1503069836873" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
                </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.jsx